import platform from 'platform'
import {
  APP_MOCK,
  APP_STORE_QRCODE,
  PLAY_STORE_QRCODE,
} from 'src/assets/images'
import {
  APP_ICON_SRC,
  APP_STORE_ICON_SRC,
  APP_STORE_URL,
  PLAY_STORE_ICON_SRC,
  PLAY_STORE_URL,
} from 'src/data/common'
import { Link } from 'src/elements/Link'
import { orange, truewhite } from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import styled from 'styled-components'

export const InstallApp = () => {
  if (platform.os?.family === 'Android')
    return (
      <MobileLayout>
        <img src={APP_ICON_SRC} alt="ONLYSTORY モバイルアプリ" />
        <p>アプリをインストールしてもっと快適につながり！！</p>
        <Link href={PLAY_STORE_URL}>
          <img src={PLAY_STORE_ICON_SRC} alt="Goole Playで手に入れよう" />
        </Link>
      </MobileLayout>
    )
  if (platform.os?.family === 'iOS' || window.innerWidth < 1024)
    return (
      <MobileLayout>
        <img src={APP_ICON_SRC} alt="ONLYSTORY モバイルアプリ" />
        <p>アプリをインストールしてもっと快適につながり！！</p>
        <Link href={APP_STORE_URL}>
          <img src={APP_STORE_ICON_SRC} alt="App Storeからダウンロード" />
        </Link>
      </MobileLayout>
    )
  return (
    <Layout>
      <Description>
        <h2>
          <p>ONLYSTORY</p>
          <p>モバイルアプリのβ版をリリース！</p>
        </h2>
        <div>
          <p>▼インストールはこちらから▼</p>
          <QRCodes>
            <div>
              <QRCode src={APP_STORE_QRCODE} alt="" />
              <p>iOS</p>
            </div>
            <div>
              <QRCode src={PLAY_STORE_QRCODE} />
              <p>Android</p>
            </div>
          </QRCodes>
        </div>
      </Description>
      <img src={APP_MOCK} alt="ONLYSTORY モバイルアプリ" />
    </Layout>
  )
}
const MobileLayout = styled.div`
  max-width: 260px;
  padding: 10px 36px;
  background-color: ${orange};
  color: ${truewhite};
  border-radius: 16px;
  img {
    display: block;
    width: 50%;
    margin: 20px auto;
    object-fit: scale-down;
  }
  p {
    font-weight: ${fontWeightBold};
    text-align: center;
  }
  a {
    img {
      width: 75%;
    }
  }
`

const Layout = styled.div`
  padding: 20px 40px;
  border-radius: 16px;
  background: linear-gradient(109.6deg, #ff6c00 11.2%, gold);
  color: ${truewhite};
  display: flex;
  align-items: center;
  height: 550px;
  > * {
    margin: 0 40px;
    height: 100%;
  }
  img {
    display: block;
  }
`

const Description = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  h2 {
    font-size: 26px;
    letter-spacing: 0.05em;
    line-height: 1.6;
  }
  > div {
    margin-top: 40px;
    > * {
      margin: 20px 0;
    }
  }
`
const QRCodes = styled.div`
  display: flex;
  justify-content: space-evenly;
`
const QRCode = styled.img`
  width: 120px;
  height: 120px;
`
